import { createSlice } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'

const initialState = {
    error: false,
    errorPhrase: "",
    info: false,
    infoPhrase: "",
    showAlert: false,
    alertType: '',
}

const settingsSlice = createSlice({
    name: "settings",
    initialState,
    reducers: {
        settingsError: (state,action) => {
            state.error = true
            state.errorPhrase = action.payload.errorPhrase
        },
        settingsInfo: (state,action) => {
            state.info = true
            state.infoPhrase = action.payload.infoPhrase
        },
        resetAlert: (state) => {
            state.error = initialState.error
            state.errorPhrase = initialState.errorPhrase
            state.info = initialState.info
            state.infoPhrase = initialState.infoPhrase
        },
        showAlert: (state,action) => {
            state.showAlert = true
            state.alertType = action.payload.alertType
        },
        hideAlert: (state) => {
            state.showAlert = false
            state.alertType = ''
        },
        reset: state => initialState,
    },
})

const persistConfig = {
    key: 'settings',
    storage: storage,
    whitelist: ['showAlert','alertType']
}

export const { settingsError, settingsInfo, setHubPage, resetHubPage, resetAlert, showAlert, hideAlert, reset } = settingsSlice.actions
export default persistReducer(persistConfig,settingsSlice.reducer)